import { useEffect } from 'react';
import { a as animate } from '../animations--PMkOS0j.js';
import '../_commonjsHelpers-jjO7Zipk.js';
import '../index-RkBJ48Nr.js';

const useAnimate = (refEl, start, rerenderData) => {
    useEffect(() => {
        if (refEl.current) {
            const animCtx = animate({
                scopeElement: refEl.current,
                ...(start !== null ? { start } : {}),
            });
            return () => animCtx.revert();
        }
        return undefined;
    }, [refEl.current, rerenderData]);
};

export { useAnimate as default };
//# sourceMappingURL=useAnimate.js.map
